import Swal from 'sweetalert2';
import baseURL from './url';

let instalada = false;
let ultimaVez = 0;
const COOLDOWN = 10000; // ms entre avisos, para no spamear cuando fallan varios fetch a la vez

function mostrarModalSoporte() {
    const ahora = Date.now();
    if (ahora - ultimaVez < COOLDOWN) return;
    ultimaVez = ahora;

    Swal.fire({
        icon: 'error',
        title: 'Error de conexión con la base de datos',
        html: 'Se alcanzó el límite de conexiones del servidor.<br/>Por favor contacta al <strong>soporte del sistema</strong> para solucionarlo.',
        confirmButtonText: 'Entendido',
        confirmButtonColor: '#0d9488',
    });
}

function esErrorLimiteConexiones(texto) {
    const t = String(texto).toLowerCase();
    return t.includes('max_connections_per_hour') ||
           t.includes('max_user_connections') ||
           t.includes('[1226]');
}

export function instalarDeteccionErrorDB() {
    if (instalada) return;
    instalada = true;

    const fetchOriginal = window.fetch.bind(window);

    window.fetch = async function (input, init) {
        const respuesta = await fetchOriginal(input, init);
        try {
            const url = typeof input === 'string' ? input : (input && input.url) || '';
            if (url.startsWith(String(baseURL))) {
                const clon = respuesta.clone();
                clon.json()
                    .then((data) => {
                        if (data && esErrorLimiteConexiones(JSON.stringify(data))) {
                            mostrarModalSoporte();
                        }
                    })
                    .catch(() => {});
            }
        } catch (e) {
            // Ignorar errores del interceptor: nunca debe romper el flujo normal
        }
        return respuesta;
    };
}
